module.exports = __webpack_public_path__ + "media/images/ic-account-f24cbc8505d2fd27987f5112b96efea2.png";